// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../../types';
import Price from '../../../../price';

export const TotalPrice = styled<typeof Price, Theme, _>(Price)`
  color: ${props => props.theme.optionPrice.priceColor.active};
  font-size: .875rem;
  line-height: 1;
  text-decoration: line-through;
`;

export const BundlePrice = styled<typeof Price, Theme, _>(Price)`
  font-size: .875rem;
  line-height: 1;
  margin-left: 1rem;
`;

export default null;
